import { JSX } from 'preact'
import { useActiveNotification } from './useActiveNotification'

export interface BannerProps {
  name: string
}

export const Banner = ({ name }: BannerProps): JSX.Element => {
  const notification = useActiveNotification(name)
  if (!notification) {
    return null
  }
  return <div className="notification">{notification}</div>
}
